import { FormularioConcursoAdmin } from '../models/admin-formularios.models';

export const ADMIN_FORMULARIOS_MOCK: FormularioConcursoAdmin[] = [
  {
    id: 'FORM-001',
    nombreFormulario: 'FONDECYT Regular 2027',
    codigoFormulario: 'FONDECYT_REG_2027',
    concurso: 'FONDECYT Regular',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Nacional',
    anio: 2027,
    descripcion: 'Formulario de postulacion para el concurso FONDECYT Regular 2027.',
    instruccionesPostulantes:
      'Revisa cuidadosamente las bases antes de comenzar. La propuesta debe quedar completa antes de la fecha de cierre.',
    mensajeInformativoSistema:
      'Los cambios guardados en borrador quedaran disponibles para continuar la postulacion mas tarde.',
    estado: 'publicado',
    fechaCreacion: '2025-05-12',
    secciones: [
      { id: 'SEC-1', titulo: 'Informacion general del proyecto', descripcion: 'Descripcion y antecedentes generales.' },
      { id: 'SEC-2', titulo: 'Instituciones y equipo de trabajo', descripcion: 'Instituciones participantes y equipo.' },
      { id: 'SEC-3', titulo: 'Presupuesto', descripcion: 'Detalle de presupuesto solicitado.' },
      { id: 'SEC-4', titulo: 'Documentos', descripcion: 'Adjuntos requeridos por el concurso.' },
    ],
    configuracion: {
      guardadoParcial: true,
      cargaArchivos: true,
      correoConfirmacion: true,
      mostrarFolio: true,
      validacionesPersonalizadas: false,
      campos: [
        { id: 'titulo', label: 'Titulo del proyecto', obligatorio: true },
        { id: 'resumen', label: 'Resumen', obligatorio: true },
        { id: 'area-ocde', label: 'Area OCDE', obligatorio: true },
        { id: 'disciplina', label: 'Disciplina', obligatorio: true },
      ],
    },
    fechas: {
      inicioPostulacion: '2025-06-01',
      cierrePostulacion: '2025-10-01',
      inicioEvaluacion: '2025-10-15',
      cierreEvaluacion: '2026-01-10',
      programarPublicacion: false,
      fechaPublicacion: '',
      horaPublicacion: '',
    },
  },
  {
    id: 'FORM-002',
    nombreFormulario: 'FONDECYT Iniciacion 2027',
    codigoFormulario: 'FONDECYT_INI_2027',
    concurso: 'FONDECYT Iniciacion',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Nacional',
    anio: 2027,
    descripcion: 'Formulario base para concursos de iniciacion.',
    instruccionesPostulantes:
      'Completa la informacion del proyecto, equipo y documentos requeridos antes de la fecha programada.',
    mensajeInformativoSistema: 'La publicacion de este formulario se encuentra programada para la fecha configurada.',
    estado: 'programado',
    fechaCreacion: '2025-05-10',
    secciones: [
      { id: 'SEC-1', titulo: 'Informacion general del proyecto', descripcion: 'Datos generales del postulante y propuesta.' },
      { id: 'SEC-2', titulo: 'Equipo de trabajo', descripcion: 'Integrantes y roles del proyecto.' },
      { id: 'SEC-3', titulo: 'Documentos', descripcion: 'Carta, CV y anexos.' },
    ],
    configuracion: {
      guardadoParcial: true,
      cargaArchivos: true,
      correoConfirmacion: true,
      mostrarFolio: true,
      validacionesPersonalizadas: true,
      campos: [
        { id: 'titulo', label: 'Titulo del proyecto', obligatorio: true },
        { id: 'duracion', label: 'Duracion del proyecto', obligatorio: true },
        { id: 'presupuesto', label: 'Presupuesto', obligatorio: true },
      ],
    },
    fechas: {
      inicioPostulacion: '2025-06-15',
      cierrePostulacion: '2025-09-20',
      inicioEvaluacion: '2025-10-01',
      cierreEvaluacion: '2025-12-20',
      programarPublicacion: true,
      fechaPublicacion: '2025-06-10',
      horaPublicacion: '09:00',
    },
  },
  {
    id: 'FORM-003',
    nombreFormulario: 'Fondo ALMA-ANID 2026',
    codigoFormulario: 'ALMA_2026',
    concurso: 'Fondo ALMA-ANID',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
    convocatoria: 'Internacional',
    anio: 2026,
    descripcion: 'Formulario tecnico para proyectos con observacion astronomica.',
    instruccionesPostulantes:
      'Adjunta los anexos tecnicos y antecedentes especializados requeridos por la convocatoria.',
    mensajeInformativoSistema: 'Este formulario sigue en preparacion y puede sufrir ajustes antes de su publicacion.',
    estado: 'borrador',
    fechaCreacion: '2025-05-08',
    secciones: [
      { id: 'SEC-1', titulo: 'Informacion general', descripcion: 'Datos del concurso y de la propuesta.' },
      { id: 'SEC-2', titulo: 'Documentos tecnicos', descripcion: 'Adjuntos y anexos especializados.' },
    ],
    configuracion: {
      guardadoParcial: true,
      cargaArchivos: true,
      correoConfirmacion: false,
      mostrarFolio: false,
      validacionesPersonalizadas: false,
      campos: [
        { id: 'resumen', label: 'Resumen tecnico', obligatorio: true },
        { id: 'anexos', label: 'Anexos tecnicos', obligatorio: true },
      ],
    },
    fechas: {
      inicioPostulacion: '2025-07-01',
      cierrePostulacion: '2025-09-01',
      inicioEvaluacion: '2025-09-15',
      cierreEvaluacion: '2025-11-10',
      programarPublicacion: false,
      fechaPublicacion: '',
      horaPublicacion: '',
    },
  },
  {
    id: 'FORM-004',
    nombreFormulario: 'Anillos de Investigacion 2026',
    codigoFormulario: 'ANILLOS_2026',
    concurso: 'Anillos de Investigacion',
    subdireccion: 'CENTROS E INVESTIGACION ASOCIATIVA',
    convocatoria: 'Nacional',
    anio: 2026,
    descripcion: 'Formulario de anillos en preparacion.',
    instruccionesPostulantes:
      'Estructura el equipo y el presupuesto por categoria antes de solicitar el patrocinio institucional.',
    mensajeInformativoSistema: 'El formulario se encuentra en borrador y aun no esta visible para postulantes.',
    estado: 'borrador',
    fechaCreacion: '2025-05-05',
    secciones: [
      { id: 'SEC-1', titulo: 'Informacion general', descripcion: 'Antecedentes generales.' },
      { id: 'SEC-2', titulo: 'Presupuesto', descripcion: 'Distribucion por categoria.' },
    ],
    configuracion: {
      guardadoParcial: true,
      cargaArchivos: true,
      correoConfirmacion: false,
      mostrarFolio: true,
      validacionesPersonalizadas: false,
      campos: [
        { id: 'titulo', label: 'Titulo del proyecto', obligatorio: true },
        { id: 'equipo', label: 'Equipo', obligatorio: true },
      ],
    },
    fechas: {
      inicioPostulacion: '2025-08-01',
      cierrePostulacion: '2025-10-05',
      inicioEvaluacion: '2025-10-20',
      cierreEvaluacion: '2025-12-10',
      programarPublicacion: false,
      fechaPublicacion: '',
      horaPublicacion: '',
    },
  },
  {
    id: 'FORM-005',
    nombreFormulario: 'FONIS 2026',
    codigoFormulario: 'FONIS_2026',
    concurso: 'FONIS',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Nacional',
    anio: 2026,
    descripcion: 'Formulario historico cerrado.',
    instruccionesPostulantes: 'Este formulario corresponde a una convocatoria cerrada y se mantiene solo para consulta.',
    mensajeInformativoSistema: 'La convocatoria ya no admite nuevas postulaciones.',
    estado: 'cerrado',
    fechaCreacion: '2025-04-20',
    secciones: [
      { id: 'SEC-1', titulo: 'Informacion general', descripcion: 'Datos del proyecto.' },
      { id: 'SEC-2', titulo: 'Documentos', descripcion: 'Adjuntos del concurso.' },
    ],
    configuracion: {
      guardadoParcial: true,
      cargaArchivos: true,
      correoConfirmacion: true,
      mostrarFolio: true,
      validacionesPersonalizadas: false,
      campos: [{ id: 'titulo', label: 'Titulo', obligatorio: true }],
    },
    fechas: {
      inicioPostulacion: '2025-03-01',
      cierrePostulacion: '2025-05-01',
      inicioEvaluacion: '2025-05-15',
      cierreEvaluacion: '2025-07-30',
      programarPublicacion: false,
      fechaPublicacion: '',
      horaPublicacion: '',
    },
  },
  {
    id: 'FORM-006',
    nombreFormulario: 'Proyectos de Investigacion 2026',
    codigoFormulario: 'PROYECTOS_INV_2026',
    concurso: 'Proyectos de Investigacion',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Nacional',
    anio: 2026,
    descripcion: 'Formulario general para propuestas de investigacion aplicada.',
    instruccionesPostulantes:
      'Completa el titulo, resumen, instituciones, presupuesto y documentos antes de enviar tu postulacion.',
    mensajeInformativoSistema: 'El sistema guardara automaticamente tus avances al cambiar de seccion.',
    estado: 'publicado',
    fechaCreacion: '2025-05-16',
    secciones: [
      { id: 'SEC-1', titulo: 'Informacion general del proyecto', descripcion: 'Descripcion y antecedentes de la propuesta.' },
      { id: 'SEC-2', titulo: 'Instituciones y equipo de trabajo', descripcion: 'Instituciones participantes y equipo del proyecto.' },
      { id: 'SEC-3', titulo: 'Presupuesto', descripcion: 'Distribucion de recursos y justificacion del gasto.' },
      { id: 'SEC-4', titulo: 'Documentos', descripcion: 'Adjuntos requeridos y anexos.' },
    ],
    configuracion: {
      guardadoParcial: true,
      cargaArchivos: true,
      correoConfirmacion: true,
      mostrarFolio: true,
      validacionesPersonalizadas: false,
      campos: [
        { id: 'titulo', label: 'Titulo del proyecto', obligatorio: true },
        { id: 'resumen', label: 'Resumen ejecutivo', obligatorio: true },
        { id: 'institucion', label: 'Institucion ejecutora', obligatorio: true },
        { id: 'presupuesto', label: 'Presupuesto total', obligatorio: true },
      ],
    },
    fechas: {
      inicioPostulacion: '2025-06-01',
      cierrePostulacion: '2025-10-01',
      inicioEvaluacion: '2025-10-10',
      cierreEvaluacion: '2026-01-15',
      programarPublicacion: false,
      fechaPublicacion: '',
      horaPublicacion: '',
    },
  },
  {
    id: 'FORM-007',
    nombreFormulario: 'Redes de Investigacion 2026',
    codigoFormulario: 'REDES_INV_2026',
    concurso: 'Redes de Investigacion',
    subdireccion: 'INVESTIGACION APLICADA',
    convocatoria: 'Internacional',
    anio: 2026,
    descripcion: 'Formulario orientado a redes de colaboracion cientifica y tecnologica.',
    instruccionesPostulantes:
      'Describe claramente el impacto de la red, los participantes y las actividades financiadas.',
    mensajeInformativoSistema: 'Puedes invitar integrantes del equipo y recomendadores desde la seccion de equipo de trabajo.',
    estado: 'publicado',
    fechaCreacion: '2025-05-15',
    secciones: [
      { id: 'SEC-1', titulo: 'Informacion general', descripcion: 'Datos del proyecto y red de colaboracion.' },
      { id: 'SEC-2', titulo: 'Equipo de trabajo', descripcion: 'Integrantes, roles e instituciones.' },
      { id: 'SEC-3', titulo: 'Presupuesto', descripcion: 'Distribucion de gastos por categoria.' },
      { id: 'SEC-4', titulo: 'Documentos', descripcion: 'Documentos exigidos por el concurso.' },
    ],
    configuracion: {
      guardadoParcial: true,
      cargaArchivos: true,
      correoConfirmacion: true,
      mostrarFolio: true,
      validacionesPersonalizadas: false,
      campos: [
        { id: 'titulo', label: 'Titulo de la red', obligatorio: true },
        { id: 'equipo', label: 'Equipo y participantes', obligatorio: true },
        { id: 'viajes', label: 'Viajes y viaticos', obligatorio: false },
      ],
    },
    fechas: {
      inicioPostulacion: '2025-06-05',
      cierrePostulacion: '2025-09-25',
      inicioEvaluacion: '2025-10-05',
      cierreEvaluacion: '2025-12-22',
      programarPublicacion: false,
      fechaPublicacion: '',
      horaPublicacion: '',
    },
  },
  {
    id: 'FORM-008',
    nombreFormulario: 'Capital Humano 2026',
    codigoFormulario: 'CAPITAL_HUMANO_2026',
    concurso: 'Capital Humano',
    subdireccion: 'CAPITAL HUMANO',
    convocatoria: 'Nacional',
    anio: 2026,
    descripcion: 'Formulario para becas y postulaciones orientadas al desarrollo de capital humano avanzado.',
    instruccionesPostulantes:
      'Completa los antecedentes academicos y adjunta certificados obligatorios antes de enviar.',
    mensajeInformativoSistema: 'La seccion de proyecto puede variar o simplificarse segun el tipo de beca.',
    estado: 'publicado',
    fechaCreacion: '2025-05-14',
    secciones: [
      { id: 'SEC-1', titulo: 'Antecedentes del postulante', descripcion: 'Datos personales y academicos.' },
      { id: 'SEC-2', titulo: 'Instituciones', descripcion: 'Programa de estudios y universidad de destino.' },
      { id: 'SEC-3', titulo: 'Documentos', descripcion: 'Certificados y CV requeridos.' },
    ],
    configuracion: {
      guardadoParcial: true,
      cargaArchivos: true,
      correoConfirmacion: true,
      mostrarFolio: true,
      validacionesPersonalizadas: false,
      campos: [
        { id: 'programa', label: 'Programa de estudios', obligatorio: true },
        { id: 'institucion', label: 'Institucion de destino', obligatorio: true },
        { id: 'certificados', label: 'Certificados academicos', obligatorio: true },
      ],
    },
    fechas: {
      inicioPostulacion: '2025-05-28',
      cierrePostulacion: '2025-08-30',
      inicioEvaluacion: '2025-09-10',
      cierreEvaluacion: '2025-11-30',
      programarPublicacion: false,
      fechaPublicacion: '',
      horaPublicacion: '',
    },
  },
];
